// import React from "react";
// // import "/pages/loader.css";

// export default function Loader() {
//   return (
//     <div className="loader-wrapper">
//       <img
//         src="/Gallerypics/Javed.png"   // put your logo path here
//         alt="Company Logo"
//         className="loader-logo"
//       />
//     </div>
//   );
// }

// components/Loader.jsx
import React from "react";
// import "./Loader.css";

export default function Loader() {
  return (
    <div className="loader-wrapper">
      <div class="spinner">
        <div><img src="/Gallerypics/Javed.png" alt="" srcset="" /></div>
        <div><img src="/Gallerypics/Javed.png" alt="" srcset="" /></div>
        <div><img src="/Gallerypics/Javed.png" alt="" srcset="" /></div>
        <div><img src="/Gallerypics/Javed.png" alt="" srcset="" /></div>
        <div><img src="/Gallerypics/Javed.png" alt="" srcset="" /></div>
        <div><img src="/Gallerypics/Javed.png" alt="" srcset="" /></div>
        
        </div>
      <h2 className="loader-text">Welcome to <span>JAS Contracts</span></h2>
    </div>
  );
}

